export const ValidationErrorKeys = {
  REQUIRED: 'form.validation.required',
  MIN_LENGTH: 'form.validation.minLength',
  MAX_LENGTH: 'form.validation.maxLength',
  GREATER_THAN: 'form.validation.greaterThan'
}
